import { Icon, IconSize } from '@doordash/design-language';
import { IconButton, IconButtonSize, IconButtonType } from '@doordash/component-button';
import { IconContainer } from './styles.js';
import React from 'react';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var generateProps = function generateProps(sharedColor, iconProps) {
  if (iconProps.isInteractive) {
    var size = iconProps.size,
        type = iconProps.type,
        accessibilityLabel = iconProps.accessibilityLabel,
        onClick = iconProps.onClick,
        target = iconProps.target,
        href = iconProps.href,
        tag = iconProps.tag;
        iconProps.isInteractive;
        var additionalIconProps = _objectWithoutProperties(iconProps, ["size", "type", "accessibilityLabel", "onClick", "target", "href", "tag", "isInteractive"]);

    return _objectSpread({
      size: size || IconButtonSize.Medium,
      type: IconButtonType.Plain,
      iconType: type,
      accessibilityLabel: accessibilityLabel,
      onClick: onClick,
      tag: tag,
      target: target,
      href: href
    }, additionalIconProps);
  } else {
    var color = iconProps.color,
        _size = iconProps.size,
        _type = iconProps.type,
        _accessibilityLabel = iconProps.accessibilityLabel;
        iconProps.isInteractive;
        var _additionalIconProps = _objectWithoutProperties(iconProps, ["color", "size", "type", "accessibilityLabel", "isInteractive"]);

    return _objectSpread({
      size: _size || IconSize.Medium,
      type: _type,
      accessibilityLabel: _accessibilityLabel,
      color: color || sharedColor
    }, _additionalIconProps);
  }
};

var ConditionalIconButton = function ConditionalIconButton(_ref) {
  var renderIconSpacer = _ref.renderIconSpacer,
      sharedColor = _ref.sharedColor,
      iconAlignment = _ref.iconAlignment,
      side = _ref.side,
      iconProps = _ref.iconProps,
      columnProps = _objectWithoutProperties(_ref, ["renderIconSpacer", "sharedColor", "iconAlignment", "side", "iconProps"]);

  var size = iconProps.size,
      isInteractive = iconProps.isInteractive;
  var shouldBeButton = isInteractive;
  var props = generateProps(sharedColor, iconProps);
  return /*#__PURE__*/React.createElement(IconContainer, {
    renderIconSpacer: renderIconSpacer,
    onClick: shouldBeButton ? function (e) {
      return e.stopPropagation();
    } : undefined,
    onKeyDown: shouldBeButton ? function (e) {
      return e.stopPropagation();
    } : undefined,
    side: side,
    iconAlignment: iconAlignment,
    shouldBeButton: shouldBeButton,
    size: size,
    columnProps: columnProps
  }, shouldBeButton ? /*#__PURE__*/React.createElement(IconButton, props) : /*#__PURE__*/React.createElement(Icon, props));
};

export { ConditionalIconButton as default };
